export default {
  "daily_by_time_zone_world_clock": "World Clock",
  "daily_by_time_zone_world_clock_show_more": "Show All",
  "daily_by_time_zone_world_clock_show_less": "Show Less",
  "daily_by_time_zone_world_clock_setting": "Clock Setting",
  "daily_by_time_zone_world_clock_setting_confirm": "Confirm",
  "daily_by_time_zone_world_clock_setting_cancel": "Cancel",
  "daily_by_time_zone_world_clock_setting_defaults": "Defaults",
  "daily_by_time_zone_world_clock_setting_customizeds": "Customized",
  "daily_by_time_zone_world_clock_setting_search": "Search",
  "daily_by_time_zone_world_clock_setting_select_all": "Select All",
  "daily_by_time_zone_world_clock_setting_search_no_result": "No search results",
  "daily_by_time_zone_world_clock_setting_select_only_one_tip": "Please select at least one world clock",
  "daily_by_time_zone_world_clock_setting_select_more_than_24_tip": "Show up to 24 world clocks",

  'daily_by_time_zone_selector_region_label': 'Region',
  'daily_by_time_zone_selector_country_label': 'Country',
  'daily_by_time_zone_selector_global': 'Global',
  'daily_by_time_zone_selector_all': 'All',
  'daily_by_time_zone_selector_total': 'Total',
  'daily_by_time_zone_selector_region_des': 'Display data results based on de-duplicated users in global markets, summary by local time zone. ',
  'daily_by_time_zone_selector_zone_des': 'Display data results based on de-duplicated users in all zones, summary by local time zone.',
  // 趋势图
  'daily_by_time_zone_trend_sdlw': 'Same Day Last Week',
  'daily_by_time_zone_trend_avg': 'Average',
  'daily_by_time_zone_trend_sum': 'Sum',
  'daily_by_time_zone_trend_expand': 'Show All',
  'daily_by_time_zone_trend_fold': 'Show Less',

  // 宽表标题
  'daily_by_timezone_Key_Metrics_Comparison': 'Key Metrics Comparison',
  // 页面标题
  'daily_by_timezone_title': 'Daily by Timezone',
  // 页面副标题
  // 'daily_by_timezone_sub_title_country': "This page shows data in the local time zone of the country.",
  // 'daily_by_timezone_sub_title_zone': "This page shows data in the local time zone of the zone.",
  'daily_by_timezone_sub_title': "This page shows local timezone data. Data of T(eg: Dec 1st) will be updated on T+2 (Dec 3rd 9:00am UTC +8)."
}
